import React, { useState } from 'react';
import "./styles.css"
import axios from 'axios'
import PhoneNumberForm from '../../Components/PhoneNumberForm';
import { toast } from 'react-toastify';
import { MAIN_URL } from '../../constants';
import { Button, Card, Input, PageHeader, PasswordInput, SegmentedControl } from '../../Components/ui';
import Field from '../../Components/ui/Field/Field';
import './NewEmployeePage.css';

const NewEmployeeForm = () => {

    const TOKEN = localStorage.getItem("admin_token")
    const [activeTab, setActiveTab] = useState('admin');
    const [formData, setFormData] = useState({
        phone_number: '',
        first_name: '',
        last_name: '',
        role: 'admin' ,
        password: '',
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    };

    const handleTabChange = (tab) => {
        setActiveTab(tab);
        setFormData((prevData) => ({
            ...prevData,
            role: tab === 'admin' ? 'admin' : 'mentor' 
        }));
    };

    const handlePhoneChange = (phone) => {
        setFormData((prevData) => ({
            ...prevData,
            phone_number: phone,
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        axios.post(`${MAIN_URL}/management/add-staff`, formData, {
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${TOKEN}`
            }
        })
        .then(response => {
            console.log(response?.data)
           toast.success("Staff successfully added!")

        })
        .catch(error => {
           const errorMessage = error.response?.data?.detail
           toast.error(errorMessage)
           console.log(errorMessage);
           
        });
        setFormData({
            first_name: "",
            last_name: "",
            password: "",
            phone_number: "",
        });
    };

    return (
        <div className="ui-staff">
            <PageHeader
                title="Xodim qo'shish"
                subtitle="Admin yoki o'qituvchi uchun yangi akkaunt yaratish"
            />
            <Card className="ui-staff__card">
                {/* autoComplete: brauzer adminning login/parolini bu formaga yozib qo'ymasligi uchun */}
                <form autoComplete='off' className="ui-staff__form" onSubmit={handleSubmit}>
                    <div className="ui-staff__role">
                        <span className="ui-staff__label">Rol</span>
                        <SegmentedControl
                            aria-label="Rol"
                            options={[
                                { value: 'admin', label: 'Admin' },
                                { value: 'teacher', label: "O'qituvchi" },
                            ]}
                            value={activeTab}
                            onChange={(tab) => handleTabChange(tab)}
                            fullWidth
                        />
                    </div>

                    <div className="ui-staff__grid">
                        <Input
                            required
                            type="text"
                            label="Ism"
                            placeholder="Masalan: Jamshid"
                            name="first_name"
                            value={formData.first_name}
                            onChange={handleChange}
                            autoComplete="off"
                        />
                        <Input
                            required
                            type="text"
                            label="Familiya"
                            placeholder="Masalan: Karimov"
                            name="last_name"
                            value={formData.last_name}
                            onChange={handleChange}
                            autoComplete="off"
                        />
                    </div>

                    <Field
                        id="staff-phone"
                        label="Telefon raqam"
                        hint="Xodim tizimga shu raqam bilan kiradi"
                        required
                    >
                        <PhoneNumberForm
                            id="staff-phone"
                            autoComplete="off"
                            phoneNumber={formData.phone_number}
                            onChange={handlePhoneChange}
                            reset={formData.phone_number === ""}
                        />
                    </Field>

                    <PasswordInput
                        required
                        label="Parol"
                        hint="Xodim tizimga kirishi uchun parol"
                        name="password"
                        value={formData.password}
                        onChange={handleChange}
                        autoComplete="new-password"
                    />

                    <div className="ui-staff__actions">
                        <Button type="button" variant="secondary">
                            Bekor qilish
                        </Button>
                        <Button type="submit">
                            Xodim qo'shish
                        </Button>
                    </div>
                </form>
            </Card>
        </div>
    );
};

export default NewEmployeeForm;